import axios from 'axios'
const url = "https://www.lefisc.com.br/api/reclef"

export default{  
    visualizar(caminhoConsulta){
        return axios
        .get(`${caminhoConsulta}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    remover(id){       
        return axios
        .delete(`${url}/consultas?hash=${id}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    getConsulta(id){
        return axios
        .get(`${url}/consultas?hash=${id}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    enviarNotas(id, json, tipoIcms) {
    
    let requestUrl = `${url}/upload?hash=${id}&tipoIcms=${tipoIcms}`;

    return axios
        .post(requestUrl, json)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
}
}